import { render, staticRenderFns } from "./job-view.vue?vue&type=template&id=22e0c5ff&scoped=true"
import script from "./job-view.vue?vue&type=script&lang=js"
export * from "./job-view.vue?vue&type=script&lang=js"
import style0 from "./job-view.vue?vue&type=style&index=0&id=22e0c5ff&prod&lang=css"
import style1 from "./job-view.vue?vue&type=style&index=1&id=22e0c5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0c5ff",
  null
  
)

export default component.exports